// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@synd/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 12,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h3",
    color: "common.ui7",
    css: css`
        margin-bottom: 0;
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "secondary",
    css: css`
        margin-top: 4px;
         ${({ isFullWidth }: { isFullWidth?: boolean }) =>
            isFullWidth
                ? css`
                      width: 100%;
                  `
                : ""}
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    variant: "primary",
    css: css`
        margin-top: 4px;
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        flex-direction: row;
        gap: 10px;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};